module.exports = __webpack_public_path__ + "img/1.f1c033a3.png";